import axios from '@/lib/drupal/api/axiosInstance';
import ArticlesModel, { ArticleData } from '@/lib/drupal/models/Articles';
import GamesModel, { DrupalGameData, ExtendedGameData, GameData } from '@/lib/drupal/models/Games';
import { pagingQueryString } from '@/lib/util/pagingQueryString';
import { AxiosResponse } from 'axios';
import { logErrorEvent } from 'react-commons';

export default class DailyGamesModel {
  static async getAllGames (_limit: number, _offset: number): Promise<GameData[]> {
    let response: AxiosResponse;
    try {
      response = await axios.get('/api/daily-games/block/all-daily-games');
    } catch (error) {
      logErrorEvent('Get All Daily Games', false, error);
      throw error;
    }

    return response.data.map((game: DrupalGameData) => GamesModel.transform(game));
  }

  static async getTopGames (_limit: number, _offset: number): Promise<GameData[]> {
    let response: AxiosResponse;
    try {
      response = await axios.get('/api/daily-games/block/top-daily-games');
    } catch (error) {
      logErrorEvent('Get Top Daily Games', false, error);
      throw error;
    }

    return response.data.map((game: DrupalGameData) => GamesModel.transform(game));
  }
  
  static async getTokenGames (_limit: number, _offset: number): Promise<GameData[]> {
    let response: AxiosResponse;
    try {
      response = await axios.get('/api/daily-games/block/token-games');
    } catch (error) {
      logErrorEvent('Get Daily Token Games', false, error);
      throw error;
    }

    return response.data.map((game: DrupalGameData) => GamesModel.transform(game));
  }
  
  static async getTrophyGames (_limit: number, _offset: number): Promise<GameData[]> {
    let response: AxiosResponse;
    try {
      response = await axios.get('/api/daily-games/block/trophy-games');
    } catch (error) {
      logErrorEvent('Get Daily Trophy Games', false, error);
      throw error;
    }

    return response.data.map((game: DrupalGameData) => GamesModel.transform(game));
  }
  
  static async getFeaturedGames (limit: number = 6, offset: number = 0): Promise<ExtendedGameData[]> {
    let response: AxiosResponse;
    try {
      response = await axios.get('/api/featured-daily-games?' + pagingQueryString(limit, offset));
    } catch (error) {
      logErrorEvent('Get Daily Featured Games', false, error);
      throw error;
    }

    return response.data.rows.map((game: DrupalGameData) => GamesModel.transformExtended(game));
  }

  static async getTaxonomyDescription (tid: string): Promise<ArticleData | null> {
    let response: AxiosResponse;
    try {
      response = await axios.get(`/api/node/article/alias?route=/taxonomy-description-${tid}`);
    } catch (error) {
      logErrorEvent('Get Taxonomy Description', false, error);
      throw error;
    }

    if (!response.data || !response.data[ 0 ]) {
      const error = new Error('Taxonomy Description Article Not Found');
      logErrorEvent(error.name, false, error);
      return null;
    }

    return ArticlesModel.transform(response.data[ 0 ]);
  }
}
